import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class EmailReservationService {
  private api = inject(ApiService);

  get() { return this.api.get('/email_reservation'); }
  getEmailSettingsHQAddress() { return this.api.get('/email_settings/hq_address'); }
  upsert(json: any) { return this.api.post('/email_reservation', json); }
  updateStatus(json: any) { return this.api.post('/email_reservation/status', json); }
  updateTargetCount(json: any) { return this.api.post('/email_reservation/target_count', json); }
  bulkCreateConditions(json: any) { return this.api.post('/email_condition', json); }
  upsertEmailSettingsHQAddress(json: any) { return this.api.post('/email_settings/hq_address', json); }
}
